module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/jszip/~/core-js/library/modules/_is-object.js
// module id = 246
// module chunks = 1